import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

/**
 * 获取开发环境Token
 
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken
    ? `Bearer ${customToken}`
    : `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc4OTUyNDc0MTcxMiwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTExNTM0In0.W850-fhcFytn-mRIbRWi64wXMKxPh19cvw3yCgsbxPVZICjgfy4Eba1JwZr-utZlF9uvGg5j_oO9pISZqFThuw`;
};

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
